import { render, staticRenderFns } from "./OmniaCollapse.vue?vue&type=template&id=856f2ce2&scoped=true&"
import script from "./OmniaCollapse.vue?vue&type=script&lang=js&"
export * from "./OmniaCollapse.vue?vue&type=script&lang=js&"
import style0 from "./OmniaCollapse.vue?vue&type=style&index=0&id=856f2ce2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856f2ce2",
  null
  
)

export default component.exports